// **  Initial State

const inis = {
  grouping: null,
  categories: null,
  date: null,
  operation: null,
  cant: null,
  type: null
}

const initialState = {
  charts: localStorage.getItem("predictAnalytics") ? (
    JSON.parse(localStorage.getItem("predictAnalytics"))
  ) : (
    [inis]
  )
}

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "HANDLE_CHART":
      return { ...state, charts: [...action.value] }
    case 'LOGOUT':
      return {...state, charts: [inis]}
    default:
      return state
  }
}

export default analyticsReducer
